import React from 'react';

export default class Menu extends React.Component {
  render() {
    return <div className="content">
      <h1 className="title is-3">Offer Menu of Resonable Choices</h1>
      <img src="/assets/images/step+4.jpeg" />
      <p>The Menu of Reasonable choices consists of the options (usually 2-3) that the clinician selects as most appropriate based on two main considerations, their knowledge of the individual patient and their knowledge of the treatments.</p>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/more/OfferMenu.js